import EmployeeService from '@/services/employee.service.js'

const state = {
  employees: [],
  stats: {
    totalEmployees: 0,
    monthlyPayroll: 0,
    totalDepartments: 0
  },
  loading: false,
  currentEmployee: null
}

const getters = {
  employees: state => state.employees,
  stats: state => state.stats,
  loading: state => state.loading,
  currentEmployee: state => state.currentEmployee
}

const actions = {
  async fetchEmployees({ commit, dispatch }, params = {}) {
    try {
      commit('SET_LOADING', true)
      const response = await EmployeeService.getEmployees(params)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_EMPLOYEES', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load employees',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchEmployeeById({ commit, dispatch }, partyId) {
    try {
      commit('SET_LOADING', true)
      const response = await EmployeeService.getEmployeeById(partyId)
      const data = response.payload?.responseData || response.payload || response
      commit('SET_CURRENT_EMPLOYEE', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load employee',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createEmployee({ commit, dispatch }, payload) {
    try {
      commit('SET_LOADING', true)
      const response = await EmployeeService.createEmployee(payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Employee created successfully',
        { root: true }
      )
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to create employee',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateEmployee({ commit, dispatch }, { partyId, payload }) {
    try {
      commit('SET_LOADING', true)
      const response = await EmployeeService.updateEmployee(partyId, payload)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Employee updated successfully',
        { root: true }
      )
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to update employee',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteEmployee({ commit, dispatch }, partyId) {
    try {
      commit('SET_LOADING', true)
      const response = await EmployeeService.deleteEmployee(partyId)
      dispatch(
        'notification/showSuccess',
        response.payload?.message || 'Employee deleted successfully',
        { root: true }
      )
      // Refresh employees list
      await dispatch('fetchEmployees')
      await dispatch('fetchStats')
      return response
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to delete employee',
        { root: true }
      )
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchStats({ commit, dispatch }) {
    try {
      const response = await EmployeeService.getStats()
      const data = response.payload?.responseData || response.payload || response
      commit('SET_STATS', data)
      return data
    } catch (error) {
      dispatch(
        'notification/showError',
        error.message || 'Failed to load stats',
        { root: true }
      )
      throw error
    }
  },

  clearCurrentEmployee({ commit }) {
    commit('SET_CURRENT_EMPLOYEE', null)
  }
}

const mutations = {
  SET_EMPLOYEES(state, employees) {
    state.employees = employees
  },
  SET_STATS(state, stats) {
    state.stats = {
      totalEmployees: stats.totalEmployees || 0,
      monthlyPayroll: stats.monthlyPayroll || 0,
      totalDepartments: stats.totalDepartments || 0
    }
  },
  SET_LOADING(state, value) {
    state.loading = value
  },
  SET_CURRENT_EMPLOYEE(state, employee) {
    state.currentEmployee = employee
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
